import "./index.css";
import { startStaticClient } from "./client/static-client";

const container = document.getElementById("root");
if (container?.dataset.prerendered === "true") {
  startStaticClient(container);
} else if (import.meta.env.DEV) {
  // Vite's editing preview has no generated document; keep normal React/HMR.
  void import("./client/development").then(({ startDevelopment }) => startDevelopment(container));
} else {
  throw new Error("The production document is missing its prerendered content");
}
